<template>
  <div>
    <el-tabs v-model="qdtab" style="margin-left: 40px;margin-right: 40px;">
      <el-tab-pane label="课程分类" name="coursetype">
        <el-row class="querypanel">
          <el-col :span="8">
            <div class="leftpanel">
              <div>课程分类列表:</div>
              <el-tree
                class="filter-tree"
                show-checkbox
                node-key="id"
                ref="course_tree_list"
                :data="course_usergroupsdata"
                :props="course_defaultProps"
                :check-strictly = "true"
                default-expand-all
                :expand-on-click-node="false"
                :render-content="course_renderugcontext">
              </el-tree>
              <div class="desinfo"> *请先增加总分类，然后依次增加，注意总分类只能有一个，总分类下可以设置三级子分类。</div>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="rightpanel">
              <el-collapse v-model="course_activeNames" accordion >
                <el-collapse-item title="总分类" name="0">
                  <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                    <el-form-item label="总分类">
                      <el-input v-model="course_gsbminfo"></el-input>
                    </el-form-item>
                    <el-form-item label="新增一级分类">
                      <el-input v-model="course_nameone" placeholder="仅新增一级分类时添加"></el-input>
                    </el-form-item>
                    <el-form-item label="新增一级图标"  class="yyzz_upload">
                      <el-upload
                        class="avatar-uploader"
                        drag
                        action=""
                        :headers="uploadHeaders"
                        :show-file-list="true"
                        :http-request="fnUploadRequest"
                        :on-success="OnSCOneResourceSuccess">
                        <img v-if="ifsconeurlok" :src="sconeurl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                    <el-button @click="course_addzero">新增总分类</el-button>
                    <el-button @click="course_changezero">修改并保存</el-button>
                    <el-button @click="course_addone">新增一级子分类</el-button>
                  </el-form>
                </el-collapse-item>
                <el-collapse-item title="一级分类" name="1">
                  <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                    <el-form-item label="当前一级分类">
                      <el-input v-model="course_gsbmone"></el-input>
                    </el-form-item>
                    <el-form-item label="当前分类次序">
                      <el-input v-model="course_indexone"></el-input>
                    </el-form-item>
                    <el-form-item label="新增二级分类">
                      <el-input v-model="course_nametwo" placeholder="仅新增二级分类时添加"></el-input>
                    </el-form-item>
                    <el-form-item label="新增或编辑(一、二级)图标"  class="yyzz_upload">
                      <el-upload
                        class="avatar-uploader"
                        drag
                        action=""
                        :headers="uploadHeaders"
                        :show-file-list="true"
                        :http-request="fnUploadRequest"
                        :on-success="OnSCTwoResourceSuccess">
                        <img v-if="ifsctwourlok" :src="sctwourl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                    <el-form-item label="二级图标链接" >
                      <el-input v-model="sc_two_url" placeholder="上传后会自动补充"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="course_changeone">修改并保存</el-button>
                      <el-button @click="course_addtwo">新增二级分类</el-button>
                    </el-form-item>
                  </el-form>
                </el-collapse-item>
                <el-collapse-item title="二级分类" name="2">
                  <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                    <el-form-item label="当前二级分类">
                      <el-input v-model="course_gsbmtwo"></el-input>
                    </el-form-item>
                    <el-form-item label="当前分类次序">
                      <el-input v-model="course_indextwo"></el-input>
                    </el-form-item>
                    <el-form-item label="新增三级分类">
                      <el-input v-model="course_namethree" placeholder="仅新增三级分类添加"></el-input>
                    </el-form-item>
                    <el-form-item label="新增或编辑(二、三级)图标"  class="yyzz_upload">
                      <el-upload
                        class="avatar-uploader"
                        drag
                        action=""
                        :headers="uploadHeaders"
                        :show-file-list="true"
                        :http-request="fnUploadRequest"
                        :on-success="OnSCThreeResourceSuccess">
                        <img v-if="ifscthreeurlok" :src="scthreeurl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                    <el-form-item label="二级图标链接" >
                      <el-input v-model="sc_three_url" placeholder="上传后会自动补充"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="course_changetwo">修改并保存</el-button>
                      <el-button @click="course_addthree">新增三级分类</el-button>
                    </el-form-item>
                    <div>

                    </div>
                  </el-form>
                </el-collapse-item>
                <el-collapse-item title="三级分类" name="3">
                  <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                    <el-form-item label="当前三级分类">
                      <el-input v-model="course_gsbmthree"></el-input>
                    </el-form-item>
                    <el-form-item label="当前分类次序">
                      <el-input v-model="course_indexthree"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="course_changethree">修改并保存</el-button>
                    </el-form-item>
                  </el-form>
                </el-collapse-item>
              </el-collapse>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="课程信息" name="courseinfo">
        <el-row class="querypanel">
          <el-col :span="24">
            <el-col :span="12">
              <el-form ref="form"  label-width="100px" label-position="left" >
                <el-form-item label="课程名称">
                  <el-input v-model="course_name" placeholder="请输入课程的关键字"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form ref="form"  label-width="100px" style="margin-left: 20px" label-position="left" >
                <el-form-item label="分类名称">
                  <el-select v-model="course_type" filterable placeholder="请选择产品类别"  height="120px">
                    <el-option
                      v-for="item in course_type_list"
                      :key="item.id.Int64"
                      :label="item.name.String"
                      :value="item.id.Int64">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
          </el-col>
          <el-col :span="24">
            <div>
              <el-button @click="query_course">查找课程</el-button>
              <el-button @click="add_newcourse">添加新课程</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            fit
            :data="data_course"
            ref="multipleTable">
            <el-table-column
              prop="id.Int64"
              label="课程编号">
            </el-table-column>
            <el-table-column
              prop="ctitle.String"
              width="180px"
              label="课程名称">
            </el-table-column>
            <el-table-column
              prop="csubtitle.String"
              label="课程子标题">
            </el-table-column>
            <el-table-column
              prop="addtime.String"
              label="添加时间">
            </el-table-column>
            <el-table-column
              label="操作"
              width="80px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑课程信息" placement="top-start">
                  <i class="fa fa-edit fa-lg opicon curpointer" v-on:click="edit_course(scope.$index, data_course)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除课程" placement="top-start">
                  <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="del_course(scope.$index, data_course)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-dialog title="课程信息" :visible.sync="vis_course_edit">
          <el-form ref="form"  label-width="120px" label-position="left" class="tabcard">
            <el-form-item label="课程名称">
              <el-input  v-model="ed_course_ctitle" placeholder="请输入课程名称"></el-input>
            </el-form-item>
            <el-form-item label="课程副标题">
              <el-input v-model="ed_course_cusbtitle" placeholder="请输入课程副标题"></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="所属讲师">
                  <el-select v-model="ed_course_teacher" filterable placeholder="请选择讲师"  height="120px">
                    <el-option
                      v-for="item in ed_course_teacherlist"
                      :key="item.id.Int64"
                      :label="item.name.String"
                      :value="item.id.Int64">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="上传课程缩略图" class="yyzz_upload">
                  <el-upload
                    class="avatar-uploader"
                    drag
                    action=""
                    :headers="uploadHeaders"
                    :show-file-list="true"
                    :http-request="fnUploadRequest"
                    :on-success="OnCourseSLTResourceSuccess">
                    <img v-if="ifcourseslturlok" :src="courseslturl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="12" >
                <ul class="infinite-list"  style="height: 240px; overflow:auto">
                  <el-tree
                    class="filter-tree"
                    show-checkbox
                    node-key="id"
                    ref="course_tree_list_ex"
                    :data="course_usergroupsdata"
                    :props="course_defaultProps"
                    :check-strictly = "true"
                    default-expand-all
                    :expand-on-click-node="false">
                  </el-tree>
                </ul>
              </el-col>
            </el-row>
            <el-form-item label="课程缩略图">
              <el-input v-model="ed_course_slt" placeholder="该地址在上传后会自动获取"></el-input>
            </el-form-item>
          </el-form>
          <div class="slipline"></div>
          <el-button class="gibasebtn" @click="save_course">保存课程</el-button>
        </el-dialog>
      </el-tab-pane>
      <!--
      <el-tab-pane label="课程章节" name="coursezj">
        <el-row>
          <el-col :span="9" style="margin-right: 10px;">
            <el-table
              fit
              highlight-current-row
              :data="data_course"
              ref="ref_course_zjinfo">
              <el-table-column
                prop="id.Int64"
                label="课程编号">
              </el-table-column>
              <el-table-column
                prop="ctitle.String"
                width="160px"
                label="课程名称">
              </el-table-column>
              <el-table-column
                label="操作"
                width="50px"
              >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="编辑课程信息" placement="top-start">
                    <i class="iconfont iconbianji ciicon  curpointer" v-on:click="edit_course(scope.$index, data_course)"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="14" >
            <el-form ref="form"  label-width="120px" label-position="left" style="border-left: 1px #ccc solid;margin-left: 40px;" class="tabcard">
              <el-form-item label="所选课程" style="margin-left: 20px;">
                <el-input  v-model="chapter_course" placeholder="所选课程名称" disabled></el-input>
              </el-form-item>
              <el-form-item label="章节标题" style="margin-left: 20px;">
                <el-input  v-model="chapter_title" placeholder="请输入章节标题"></el-input>
              </el-form-item>
              <el-form-item label="章节子标题" style="margin-left: 20px;">
                <el-input v-model="chapter_subtitle" placeholder="请输入章节子标题"></el-input>
              </el-form-item>
              <el-form-item label="是否允许试听" style="margin-left: 20px;">
                <el-select v-model="ifyunxuinfo" filterable placeholder="请选择是否允许试听" >
                  <el-option
                    v-for="item in ifyunxu"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="上传章节缩略图" style="margin-left: 20px;" class="yyzz_upload">
                <el-upload
                  class="avatar-uploader"
                  drag
                  action=""
                  :headers="uploadHeaders"
                  :show-file-list="true"
                  :http-request="fnUploadRequest"
                  :on-success="OnZJSLTResourceSuccess">
                  <img v-if="ifzjslturlok" :src="zjslturl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="章节缩略图链接" style="margin-left: 20px;">
                <el-input v-model="chapter_slt_url" placeholder="上传后会自动补充"></el-input>
              </el-form-item>
              <div style="margin-left: 20px;">
                <el-button @click="add_chapter">保存新章节</el-button>
                <el-button @click="save_chapter">修改章节</el-button>
              </div>
            </el-form>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="border-top: 1px #ccc solid; padding-top: 20px;">
            <el-table
              fit
              highlight-current-row
              :data="data_chapter"
              ref="ref_charpter_zjinfo">
              <el-table-column
                prop="id.Int64"
                label="章节编号">
              </el-table-column>
              <el-table-column
                prop="ztitle.String"
                width="180px"
                label="章节名称">
              </el-table-column>
              <el-table-column
                prop="zsubtitle.String"
                width="180px"
                label="章节子标题">
              </el-table-column>
              <el-table-column
                prop="zimgurl.String"
                width="180px"
                label="章节图片">
              </el-table-column>
              <el-table-column
                prop="ifprice"
                label="是否允许试听">
                <template slot-scope="scope">
                  <div v-if="scope.row.ifprice === 0">
                    设定错误
                  </div>
                  <div v-else-if="scope.row.ifprice === 1">
                    不允许试听
                  </div>
                  <div v-else-if="scope.row.ifprice === 2">
                    允许试听
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="80px"
              >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="编辑章节信息" placement="top-start">
                    <i class="iconfont iconbianji ciicon  curpointer" v-on:click="edit_chapter(scope.$index, data_chapter)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除章节" placement="top-start">
                    <i class="iconfont iconshanchu ciicon  curpointer" v-on:click="del_chapter(scope.$index, data_chapter)"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
      -->
      <el-tab-pane label="课程描述" name="coursedes">
        <el-row class="querypanel">
          <el-col :span="24">
            <el-col :span="12">
              <el-form ref="form"  label-width="100px" label-position="left" >
                <el-form-item label="课程名称">
                  <el-input v-model="course_name" placeholder="请输入课程的关键字"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form ref="form"  label-width="100px" style="margin-left: 20px" label-position="left" >
                <el-form-item label="分类名称">
                  <el-select v-model="course_type" filterable placeholder="请选择产品类别"  height="120px">
                    <el-option
                      v-for="item in course_type_list"
                      :key="item.id.Int64"
                      :label="item.name.String"
                      :value="item.id.Int64">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
          </el-col>
          <el-col :span="24">
            <div>
              <el-button @click="query_coursedes">查找课程描述</el-button>
              <el-button @click="add_newcoursedes">添加新描述</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-col :span="24">
            <el-table
              fit
              :data="data_des"
              ref="multipleTable">
              <el-table-column
                prop="id.Int64"
                width="80px"
                label="描述编号">
              </el-table-column>
              <el-table-column
                prop="ccontext.String"
                label="课程描述">
              </el-table-column>
              <el-table-column
                label="操作"
                width="80px"
              >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="编辑课程描述" placement="top-start">
                    <i class="fa fa-edit fa-lg opicon curpointer" v-on:click="edit_course_des(scope.$index, data_des)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除描述" placement="top-start">
                    <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="del_course_des(scope.$index, data_des)"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-dialog title="课程描述" :visible.sync="vis_despanel">
            <el-row class="querypanel">
              <el-col :span="24">
                <el-table
                  fit
                  highlight-current-row
                  :data="data_course"
                  ref="ref_course_desinfo">
                  <el-table-column
                    prop="id.Int64"
                    label="课程编号">
                  </el-table-column>
                  <el-table-column
                    prop="ctitle.String"
                    width="180px"
                    label="课程名称">
                  </el-table-column>
                  <el-table-column
                    prop="csubtitle.String"
                    label="课程子标题">
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="80px"
                  >
                    <template slot-scope="scope">
                      <el-tooltip class="item" effect="dark" content="编辑该课程" placement="top-start">
                        <i class="fa fa-edit fa-lg opicon curpointer" v-on:click="edit_kc(scope.$index, data_course)"></i>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
            <el-row v-if="cur_course !== ''" style="margin-top:20px; margin-bottom:20px; color:#999;">当前选择的课程： {{ cur_course.ctitle.String }}
            </el-row>
            <el-row class="querypanel">
              <el-col :span="24" style="min-height: 380px">
                <quill-editor
                  v-model="descontext"
                  ref="myQuillEditor"
                  :options="editorOption"
                  @change="onEditorChange($event)"
                >
                </quill-editor>
              </el-col>
            </el-row>
            <el-row class="querypanel">
              <el-button @click="save_coursedes">保存课程描述</el-button>
            </el-row>
          </el-dialog>
          <el-dialog :title="select_uppathtitle" :visible.sync="vis_upfilepanel">
            <el-row class="showpcinfo">
              <el-col :span="12">
                <el-form  label-width="120px">
                  <el-form-item label="上传资料" class="yyzz_upload">
                    <el-upload
                      class="avatar-uploader"
                      multiple
                      drag
                      action=""
                      :on-success="fnUploadSuccess"
                      :headers="uploadHeaders"
                      :show-file-list="true"
                      :http-request="fnUploadRequest"
                      :limit="files">
                    </el-upload>
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="12">
                <el-collapse v-model="activeName" accordion>
                  <el-collapse-item title="上传说明" name="1">
                    <div>1、您可以上传任何类型的资料。</div>
                    <div>2、上传前一定要看好上传的路径！</div>
                    <div>3、上传时，上传文件下方会有上传进度。</div>
                  </el-collapse-item>
                </el-collapse>
              </el-col>
            </el-row>
          </el-dialog>
        </el-row>
      </el-tab-pane>
      <!--
      <el-tab-pane label="课程上传" name="courseup">
        <el-row>
          <el-col :span="9" style="margin-right: 10px;">
            <el-form ref="form"  label-width="100px" style="margin-left: 20px" label-position="left" >
              <el-form-item label="课程名称">
                <el-select v-model="cur_course_id" filterable placeholder="请选择课程"  height="120px" @change="select_course">
                  <el-option
                    v-for="item in cur_course_list"
                    :key="item.id.Int64"
                    :label="item.ctitle.String"
                    :value="item.id.Int64">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-table
              fit
              highlight-current-row
              :data="data_chapter"
              ref="ref_kcsc_chapter">
              <el-table-column
                prop="id.Int64"
                label="章节编号">
              </el-table-column>
              <el-table-column
                prop="ztitle.String"
                width="160px"
                label="章节名称">
              </el-table-column>
              <el-table-column
                label="操作"
                width="50px"
              >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="编辑章节信息" placement="top-start">
                    <i class="iconfont iconbianji ciicon  curpointer" v-on:click="edit_chapter(scope.$index, data_chapter)"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="14" >
            <el-form ref="form"  label-width="120px" label-position="left" style="border-left: 1px #ccc solid;margin-left: 40px;" class="tabcard">
              <el-form-item label="所选章节" style="margin-left: 20px;">
                <el-input  v-model="chapter_course" placeholder="所选章节信息" disabled="false"></el-input>
              </el-form-item>
              <el-form-item label="资源类型" style="margin-left: 20px;">
                <el-select v-model="uptype" filterable placeholder="请选择资源类型"  height="120px">
                  <el-option
                    v-for="item in uptypelist"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="上传素材" style="margin-left: 20px;" class="yyzz_upload">
                <el-upload
                  class="avatar-uploader"
                  drag
                  action=""
                  :headers="uploadHeaders"
                  :show-file-list="true"
                  :file-list="kcsc_list"
                  :http-request="fnUploadRequest"
                  :on-success="OnSCResourceSuccess">
                  <img v-if="ifscurlok" :src="scurl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="素材链接" style="margin-left: 20px;">
                <el-input v-model="sc_slt_url" placeholder="上传后会自动补充"></el-input>
              </el-form-item>
              <div style="margin-left: 20px;">
                <el-button @click="add_chapter">保存素材</el-button>
              </div>
            </el-form>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="border-top: 1px #ccc solid; padding-top: 20px;">
            <el-table
              fit
              :data="data_sc"
              ref="multipleTable">
              <el-table-column
                prop="id.Int64"
                label="资源编号">
              </el-table-column>
              <el-table-column
                prop="ctype"
                label="资源类型">
                <template slot-scope="scope">
                  {{uptypelist[scope.row.ctype - 1].label}}
                </template>
              </el-table-column>
              <el-table-column
                prop="curl.String"
                width="520px"
                label="资源地址">
              </el-table-column>
              <el-table-column
                label="操作"
                width="80px"
              >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="编辑资源信息" placement="top-start">
                    <i class="iconfont iconbianji ciicon  curpointer" v-on:click="edit_sc(scope.$index, data_sc)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除资源" placement="top-start">
                    <i class="iconfont iconshanchu ciicon  curpointer" v-on:click="del_sc(scope.$index, data_sc)"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane >
      -->
      <el-tab-pane label="课程上/下架" name="coursesxj">
        <el-row class="querypanel">
          <el-form ref="form"  label-width="100px" label-position="left" >
            <el-col :span="12" >
              <el-form-item label="课程名称">
                <el-input v-model="course_name" placeholder="请输入课程的关键字"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" >
              <el-form-item label="分类名称" style="margin-left: 40px;">
                <el-select v-model="course_type" filterable placeholder="请选择产品类别"  height="120px">
                  <el-option
                    v-for="item in course_type_list"
                    :key="item.id.Int64"
                    :label="item.name.String"
                    :value="item.id.Int64">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课程状态" >
                <el-select v-model="sxjtype" filterable placeholder="请选择资源类型"  height="120px">
                  <el-option
                    v-for="item in sxjtypelist"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
          <el-col :span="24">
            <div>
              <el-button @click="query_cur_course_sxj">查找课程</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            fit
            :data="data_course_sxj"
            ref="multipleTable">
            <el-table-column
              prop="id.Int64"
              label="课程编号">
            </el-table-column>
            <el-table-column
              prop="ctitle.String"
              width="320px"
              label="课程名称">
            </el-table-column>
            <el-table-column
              prop="csubtitle.String"
              label="课程子标题">
            </el-table-column>
            <el-table-column
              label="操作"
              width="80px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="变更上架状态" placement="top-start">
                  <i class="fa fa-edit fa-lg opicon curpointer" v-on:click="edit_course_sxj(scope.$index, data_course_sxj)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="课程定价" name="coursedj">
        <el-row>
          <el-col :span="9" style="margin-right: 10px; margin-bottom: 40px;">
            <el-table
              fit
              highlight-current-row
              :data="data_course"
              ref="ref_course_djinfo">
              <el-table-column
                prop="id.Int64"
                label="课程编号">
              </el-table-column>
              <el-table-column
                prop="ctitle.String"
                width="160px"
                label="课程名称">
              </el-table-column>
              <el-table-column
                label="操作"
                width="50px"
              >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="编辑课程信息" placement="top-start">
                    <i class="fa fa-edit fa-lg opicon curpointer" v-on:click="edit_course_price(scope.$index, data_course)"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="14" >
            <el-form ref="form"  label-width="120px" label-position="left" style="border-left: 1px #ccc solid;margin-left: 40px;" class="tabcard">
              <el-form-item label="所选课程" style="margin-left: 20px;">
                <el-input  v-model="course_select" placeholder="所选课程名称" disabled="false"></el-input>
              </el-form-item>
              <el-form-item label="实时售价" style="margin-left: 20px;">
                <el-input  v-model="course_price" placeholder="请输入课程售价"></el-input>
              </el-form-item>
              <div style="margin-left: 20px;">
                <el-button @click="save_price">保存课程售价</el-button>
              </div>
            </el-form>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="border-top: 1px #ccc solid; padding-top: 20px;">
            <el-table
              fit
              :data="data_price"
              ref="multipleTable">
              <el-table-column
                prop="id.Int64"
                width="100px"
                label="编号">
              </el-table-column>
              <el-table-column
                prop="price.String"
                label="售价">
              </el-table-column>
              <el-table-column
                label="操作"
                width="80px"
              >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="编辑售价信息" placement="top-start">
                    <i class="fa fa-edit fa-lg opicon curpointer" v-on:click="edit_price(scope.$index, data_price)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除售价" placement="top-start">
                    <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="del_price(scope.$index, data_price)"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
import ElDialog from '../../../node_modules/element-ui/packages/dialog/src/component'
import global_ from '../../store/modules/ossparams.vue'
import * as Quill from 'quill'
import Utils from '../../util/utils'
import Video from '../../util/video'
import {quillRedefine} from 'vue-quill-editor-upload'
import {quillEditor} from 'vue-quill-editor'
var OSS = require('ali-oss')
Quill.register(Video, true)
Vue.prototype.$http = axios
var that
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],
  [{'header': 1}, {'header': 2}],
  [{'list': 'ordered'}, {'list': 'bullet'}],
  [{ script: 'sub' }, { script: 'super' }],
  [{'indent': '-1'}, {'indent': '+1'}],
  [{'direction': 'rtl'}],
  [{'size': ['small', false, 'large', 'huge']}],
  [{'header': [1, 2, 3, 4, 5, 6, false]}],
  [{'color': []}, {'background': []}],
  [{'font': []}],
  [{'align': []}],
  ['link', 'image', 'video'],
  ['clean']
]
export default {
  components: {ElDialog, quillEditor, quillRedefine},
  name: 'CourseMana',
  data () {
    return {
      qdtab: 'courseinfo',
      course_usergroupsdata: [],
      ifsconeurlok: false,
      sconeurl: '',
      ifsctwourlok: false,
      sctwourl: '',
      ifscthreeurlok: false,
      scthreeurl: '',
      sc_three_url: '',
      sc_two_url: '',
      sc_one_url: '',
      data_course_sxj: [],
      course_showcuslist: true,
      course_query_cusdata: [],
      course_query_ug_cusname: '',
      khid: '',
      course_activeNames: [],
      course_query_ug_cusno: '',
      course_selectnode: [],
      loading: false,
      course_gsbminfo: '',
      course_gsbmone: '',
      course_gsbmtwo: '',
      course_gsbmthree: '',
      uploadHeaders: { /// 上传参数头
        authorization: ''
      },
      course_nameone: '',
      course_nametwo: '',
      course_namethree: '',
      course_indexone: '',
      course_indextwo: '',
      course_indexthree: '',
      course_treereccount: 0,
      course_defaultProps: {
        children: 'Children',
        label: 'name'
      },
      cur_course: '',
      course_name: '',
      data_course: [],
      course_type_list: [],
      course_type: '',
      vis_course_edit: false,
      ed_course_ctitle: '',
      ed_course_cusbtitle: '',
      ed_course_type: '',
      ed_course_typelist: [],
      ed_course_teacher: '',
      ed_course_teacherlist: [],
      selectcourse: '',
      ifedit: false,
      ifcourseslturlok: false,
      ed_course_slt: '',
      courseslturl: '',
      data_des: [],
      editorOption: {},
      vis_upfilepanel: false,
      select_uppathtitle: '',
      activeName: '1',
      upfiletype: '',
      descontext: '',
      vis_despanel: false,
      ifdesedit: false,
      selectcoursedes: '',
      files: 50,
      data_price: [],
      course_select: '',
      chapter_subtitle: '',
      course_price: '',
      chapter_slt_url: '',
      ifzjslturlok: false,
      zjslturl: '',
      cur_course_data: '',
      ifzjedit: false,
      cur_charpter_data: '',
      sxjtype: '1',
      sxjtypelist: [{
        value: '1',
        label: '上架'
      }, {
        value: '2',
        label: '下架'
      }]
    }
  },
  created: function () {
    this.editorOption =
      {
        uploadConfig: {
          methods: 'POST',
          res: (respnse) => {
            console.log(respnse)
            return respnse.info
          }
        },
        methods: 'POST',
        size: 5100,
        accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',
        // input点击事件  formData是提交的表单实体
        change: (formData) => {
        },
        // 设置请求头 xhr: 异步请求， formData: 表单对象
        header: (xhr, formData) => {
          // xhr.setRequestHeader('myHeader','myValue');
          // formData.append('token', '1234')
        },
        // start: function (){}
        start: () => {
        },
        end: () => {
        },
        success: () => {
          console.log('上传成功')
        },
        error: () => {
        },
        placeholder: '请在此输入内容',
        theme: 'snow',
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              'image': function (value) {
                that.vis_upfilepanel = true
                that.select_uppathtitle = '上传图片'
                that.upfiletype = 'image'
              },
              'video': function (value) {
                that.vis_upfilepanel = true
                that.select_uppathtitle = '上传视频'
                that.upfiletype = 'video'
              }
            }
          }
        }
      }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    console.log(that)
    that.$options.methods.getcoursetypetree()
    that.$options.methods.getcoursetype()
    that.$options.methods.query_coursetype()
    that.$options.methods.query_teacher()
    that.$options.methods.query_course()
  },
  methods: {
    course_renderugcontext (h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <span>
            <span>{data.name}</span>
          </span>
          <span>
            <i class="fa fa-pencil-square-o gtopicon" on-click={ () => this.course_edit(node, data)}> </i>
            <i class="fa fa-trash-o gtopicon" on-click={ () => this.course_remove(node, data)}> </i>
          </span>
        </span>
      )
    },
    getcoursetypetree () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/gtct',
        method: 'post',
        data: {
          cusid: parseInt(that.khid),
          parentid: -1
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.course_usergroupsdata = JSON.parse(res.data.data)
            that.course_treereccount = JSON.parse(res.data.data).length
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    getcoursetype () {
      var qstr = 'cusid =' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/qct',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: ' order by id desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取产品数据')
            localStorage.setItem('courseinfo', res.data.data)
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.course_type_list = JSON.parse(res.data.data)
            that.ed_course_typelist = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    course_edit (node, data) {
      console.log(node)
      console.log(data)
      this.course_selectnode = data
      this.course_activeNames = [data.level.toString()]
      switch (data.level) {
        case 0: {
          that.course_gsbminfo = data.name
          break
        }
        case 1: {
          that.course_gsbmone = data.name
          that.course_indexone = data.sortindex
          if (data.imgurl.Valid && data.imgurl.String !== '') {
            that.ifsctwourlok = true
            that.sctwourl = data.imgurl.String
            that.sc_two_url = data.imgurl.String
          } else {
            that.ifsctwourlok = false
            that.sctwourl = ''
            that.sc_two_url = ''
          }
          break
        }
        case 2: {
          that.course_gsbmtwo = data.name
          that.course_indextwo = data.sortindex
          if (data.imgurl.Valid && data.imgurl.String !== '') {
            that.ifscthreeurlok = true
            that.scthreeurl = data.imgurl.String
            that.sc_three_url = data.imgurl.String
          } else {
            that.ifscthreeurlok = false
            that.scthreeurl = ''
            that.sc_three_url = ''
          }
          break
        }
        case 3: {
          that.course_gsbmthree = data.name
          that.course_indexthree = data.sortindex
          break
        }
      }
    },
    course_remove (node, data) {
      console.log(node)
      console.log(data)
      var idlist = []
      if (data.haschild === 0) {
        idlist.push(data.id)
      } else {
        idlist.push(data.id)
        var cnode = data.Children
        for (var index in cnode) {
          console.log(cnode[index])
          idlist.push(cnode[index].id)
          if (cnode[index].haschild === 0) {
          } else {
            var cinode = cnode[index].Children
            for (var i in cinode) {
              idlist.push(cinode[i].id)
              if (cinode[i].haschild === 0) {
              } else {
                var ciinode = cinode[i].Children
                for (var j in ciinode.Children) {
                  idlist.push(ciinode.Children[j].id)
                  if (cinode[i].haschild === 0) {
                  } else {
                    for (var k in ciinode.Children) {
                      idlist.push(ciinode.Children[k].id)
                    }
                  }
                }
              }
            }
          }
        }
      }
      var idstr = 'id in (' + idlist + ')'
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/dct',
        method: 'post',
        data: {
          whereinfo: {String: idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.success) {
              that.$http({
                url: 'https://api.sqnetsoft.cn/course/gtct',
                method: 'post',
                data: {
                  cusid: parseInt(that.khid),
                  parentid: -1
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  that.course_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    course_changezero () {
      console.log(this.course_selectnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/aauct',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.course_selectnode.id), Valid: true},
          cusid: parseInt(this.khid),
          name: {String: this.course_gsbminfo, Valid: true},
          level: parseInt(this.course_selectnode.level),
          haschild: parseInt(this.course_selectnode.haschild),
          parentid: parseInt(-1)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/course/gtct',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.course_usergroupsdata = JSON.parse(res.data.data)
                if (res.data.success) {
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    course_addzero () {
      if (that.course_treereccount <= 0) {
        that.$http({
          url: 'https://api.sqnetsoft.cn/course/aauct',
          method: 'post',
          data: {
            cusid: parseInt(that.khid),
            name: {String: that.course_gsbminfo, Valid: true},
            level: parseInt(0),
            haschild: parseInt(0),
            parentid: parseInt(-1)
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$http({
                url: 'https://api.sqnetsoft.cn/course/gtct',
                method: 'post',
                data: {
                  cusid: parseInt(that.khid),
                  parentid: -1
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    that.$message({
                      type: 'success',
                      message: '添加成功!'
                    })
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        that.$message({
          type: 'error',
          message: '只能保留一个总类!'
        })
      }
    },
    course_changeone () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/aauct',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.course_selectnode.id), Valid: true},
          cusid: parseInt(this.khid),
          name: {String: this.course_gsbmone, Valid: true},
          level: parseInt(this.course_selectnode.level),
          haschild: parseInt(this.course_selectnode.haschild),
          parentid: parseInt(this.course_selectnode.parentid),
          imgurl: {String: this.sctwourl, Valid: true},
          sortindex: parseInt(this.course_indexone)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/course/gtct',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.course_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    course_changetwo () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/aauct',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.course_selectnode.id), Valid: true},
          cusid: parseInt(this.khid),
          name: {String: this.course_gsbmtwo, Valid: true},
          level: parseInt(this.course_selectnode.level),
          haschild: parseInt(that.course_selectnode.haschild),
          parentid: parseInt(that.course_selectnode.parentid),
          imgurl: {String: this.scthreeurl, Valid: true},
          sortindex: parseInt(this.course_indextwo)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/course/gtct',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.course_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    course_changethree () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/aauct',
        method: 'post',
        data: {
          id: {Int64: parseInt(that.course_selectnode.id), Valid: true},
          cusid: parseInt(that.khid),
          name: {String: that.course_gsbmthree, Valid: true},
          level: parseInt(that.course_selectnode.level),
          haschild: parseInt(that.course_selectnode.haschild),
          parentid: parseInt(that.course_selectnode.parentid),
          sortindex: parseInt(this.course_indexthree)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/course/gtct',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.course_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    course_addone () {
      console.log(this.course_selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.course_selectnode.id), Valid: true},
        cusid: parseInt(this.khid),
        name: {String: this.course_gsbminfo, Valid: true},
        level: parseInt(this.course_selectnode.level),
        haschild: parseInt(1),
        parentid: parseInt(this.course_selectnode.parentid),
        imgurl: {String: this.course_selectnode.imgurl.String, Valid: true},
        sortindex: parseInt(1)
      }
      var newobj = {
        cusid: parseInt(this.khid),
        name: {String: this.course_nameone, Valid: true},
        level: parseInt(this.course_selectnode.level) + 1,
        haschild: parseInt(0),
        parentid: parseInt(this.course_selectnode.id),
        imgurl: {String: this.sconeurl, Valid: true},
        sortindex: parseInt(1)
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/paauct',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/course/gtct',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.course_usergroupsdata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    course_addtwo () {
      console.log(this.course_selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.course_selectnode.id), Valid: true},
        cusid: parseInt(this.khid),
        name: {String: this.course_gsbmone, Valid: true},
        level: parseInt(this.course_selectnode.level),
        haschild: parseInt(1),
        parentid: parseInt(this.course_selectnode.parentid),
        imgurl: {String: this.course_selectnode.imgurl.String, Valid: true},
        sortindex: parseInt(1)
      }
      var newobj = {
        cusid: parseInt(this.khid),
        name: {String: this.course_nametwo, Valid: true},
        level: parseInt(this.course_selectnode.level) + 1,
        haschild: parseInt(0),
        parentid: parseInt(this.course_selectnode.id),
        imgurl: {String: this.sctwourl, Valid: true},
        sortindex: parseInt(1)
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      console.log(newnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/paauct',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/course/gtct',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.course_usergroupsdata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    course_addthree () {
      console.log(this.course_selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.course_selectnode.id), Valid: true},
        cusid: parseInt(this.khid),
        name: {String: this.course_gsbmtwo, Valid: true},
        level: parseInt(this.course_selectnode.level),
        haschild: parseInt(1),
        imgurl: {String: this.course_selectnode.imgurl.String, Valid: true},
        parentid: parseInt(this.course_selectnode.parentid),
        sortindex: parseInt(1)
      }
      var newobj = {
        cusid: parseInt(this.khid),
        name: {String: this.course_namethree, Valid: true},
        level: parseInt(this.course_selectnode.level) + 1,
        haschild: parseInt(0),
        parentid: parseInt(this.course_selectnode.id),
        imgurl: {String: this.scthreeurl, Valid: true},
        sortindex: parseInt(1)
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      console.log(newnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/paauct',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/course/gtct',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.course_usergroupsdata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    query_coursetype: function () {
      var qstr = 'cusid =' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/qct',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: ' order by id desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取产品数据')
            localStorage.setItem('courseinfo', res.data.data)
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.course_type_list = JSON.parse(res.data.data)
            that.ed_course_typelist = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    query_teacher: function () {
      console.log('查询讲师')
      var qstr = 'cusid =' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/qti',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: ' order by id desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取讲师数据')
            that.ed_course_teacherlist = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    query_course: function () {
      console.log('查询课程')
      var qstr = 'cusid =' + that.khid
      if (that.course_name !== null && that.course_name !== '') {
        qstr = qstr + " and ctitle like '%" + that.course_name + "%' "
      }
      if ((that.course_type !== null && that.course_type !== '') && that.course_type !== 195) {
        qstr = qstr + ' and find_in_set(' + that.course_type + ', owntypes)'
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/qci',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: ' order by addtime desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取产品数据')
            localStorage.setItem('courseinfo', res.data.data)
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_course = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    add_newcourse: function () {
      this.ifedit = false
      this.vis_course_edit = true
      this.ed_course_ctitle = ''
      this.ifcourseslturlok = false
      this.courseslturl = ''
      this.ed_course_cusbtitle = ''
      this.ed_course_type = ''
      this.ed_course_teacher = ''
      this.ed_course_slt = ''
      setTimeout(() => {
        console.log(that.$refs.course_tree_list_ex)
        that.$refs.course_tree_list_ex.setCheckedKeys([])
      }, 0)
    },
    save_course: function () {
      console.log(this.ed_course_ctitle)
      console.log(this.ed_course_cusbtitle)
      console.log(this.ed_course_type)
      console.log(this.ed_course_teacher)
      console.log(this.ed_course_slt)
      let addtime = Utils.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss') // 当前时间
      var gtlisttmp = this.$refs.course_tree_list_ex.getCheckedKeys()
      console.log(this.$refs.course_tree_list_ex)
      console.log(gtlisttmp)
      var owntype = []
      for (var gtindex in gtlisttmp) {
        var gtinfotmp = gtlisttmp[gtindex]
        owntype.push(gtinfotmp)
      }
      var adata
      if (this.ifedit) {
        adata = {
          id: {Int64: parseInt(this.selectcourse.id.Int64), Valid: true},
          ctitle: {String: this.ed_course_ctitle, Valid: true},
          csubtitle: {String: this.ed_course_cusbtitle, Valid: true},
          owntypes: {String: owntype.join(','), Valid: true},
          ownteacherid: {Int64: parseInt(this.ed_course_teacher), Valid: true},
          cimgurl: {String: this.ed_course_slt, Valid: true},
          addtime: {String: addtime, Valid: true},
          cusid: parseInt(this.khid)
        }
      } else {
        adata = {
          ctitle: {String: this.ed_course_ctitle, Valid: true},
          csubtitle: {String: this.ed_course_cusbtitle, Valid: true},
          owntypes: {String: owntype.join(','), Valid: true},
          ownteacherid: {Int64: parseInt(this.ed_course_teacher), Valid: true},
          cimgurl: {String: this.ed_course_slt, Valid: true},
          addtime: {String: addtime, Valid: true},
          cusid: parseInt(this.khid)
        }
      }
      console.log(adata)
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/aauci',
        method: 'post',
        data: adata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.vis_course_edit = false
            that.$options.methods.query_course()
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    edit_course: function (index, data) {
      this.vis_course_edit = true
      this.selectcourse = data[index]
      console.log(this.selectcourse)
      var tmpdata = this.selectcourse.owntypes.String.split(',')
      var smdata = []
      for (let index in tmpdata) {
        smdata.push(tmpdata[index])
      }
      setTimeout(() => {
        console.log(that.$refs.course_tree_list_ex)
        that.$refs.course_tree_list_ex.setCheckedKeys(tmpdata)
      }, 0)
      this.ifedit = true
      this.ed_course_ctitle = this.selectcourse.ctitle.String
      this.ed_course_cusbtitle = this.selectcourse.csubtitle.String
      this.ed_course_teacher = parseInt(this.selectcourse.ownteacherid.Int64)
      this.ed_course_slt = this.selectcourse.cimgurl.String
      this.ifcourseslturlok = true
      this.courseslturl = this.selectcourse.cimgurl.String
    },
    del_course: function (index, data) {
      var curselectdata = data[index]
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/dci',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
            // 移除该条数据
            data.splice(dataindex, 1)
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    query_coursedes: function () {
      var qstr = 'cusid =' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/qcd',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: ' order by id desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取产品数据')
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_des = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    add_newcoursedes: function () {
      console.log('增加新课程')
      this.ifdesedit = false
      this.descontext = ''
      this.vis_despanel = true
      console.log(this.ifdesedit)
      console.log(this.descontext)
      console.log(this.vis_despanel)
    },
    edit_course_des: function (index, data) {
      this.ifdesedit = true
      this.vis_despanel = true
      this.selectcoursedes = data[index]
      this.descontext = this.selectcoursedes.ccontext.String
      var dataindex = this.data_course.findIndex(d => d.id.Int64 === this.selectcoursedes.id.Int64)
      this.cur_course = this.data_course[dataindex]
      setTimeout(() => {
        that.$refs.ref_course_desinfo.setCurrentRow(that.cur_course)
        that.$refs.ref_course_desinfo.toggleRowSelection(that.cur_course)
      }, 0)
    },
    edit_kc: function (index, data) {
      this.cur_course = data[index]
    },
    del_course_des: function (index, data) {
      var curselectdata = data[index]
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/dcd',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
            // 移除该条数据
            data.splice(dataindex, 1)
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    save_coursedes: function () {
      console.log(this.$refs.ref_course_desinfo)
      var adata = {
        id: {Int64: parseInt(that.cur_course.id.Int64), Valid: true},
        ccontext: {String: this.descontext, Valid: true},
        cusid: parseInt(this.khid)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/aaucd',
        method: 'post',
        data: adata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.vis_despanel = false
            that.$options.methods.query_coursedes()
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    query_price: function (qstr) {
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/qcp',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: ' order by id desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取产品数据')
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_price = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    edit_course_price: function (index, data) {
      this.cur_course_data = data[index]
      this.$refs.ref_course_djinfo.setCurrentRow(data[index])
      this.course_price = ''
      this.course_select = this.cur_course_data.ctitle.String
      var qstr = 'cusid =' + that.khid + ' and id=' + this.cur_course_data.id.Int64
      that.$options.methods.query_price(qstr)
    },
    save_price: function () {
      var adata = {
        id: {Int64: parseInt(this.cur_course_data.id.Int64), Valid: true},
        price: {String: this.course_price, Valid: true},
        cusid: parseInt(this.khid)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/aaucp',
        method: 'post',
        data: adata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.vis_despanel = false
            that.ifzjedit = false
            var qstr = 'id=' + that.cur_course_data.id.Int64
            that.$options.methods.query_price(qstr)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    edit_price: function (index, data) {
      var curselectdata = data[index]
      that.ifzjedit = true
      this.cur_charpter_data = curselectdata
      this.course_price = curselectdata.price.String
    },
    del_price: function (index, data) {
      var curselectdata = data[index]
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/dcp',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
            // 移除该条数据
            data.splice(dataindex, 1)
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    async OnCourseSLTResourceSuccess (res, file, fileList) {
      if (res.res.status === 200) {
        this.ed_course_slt = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
        this.ifcourseslturlok = true
        this.courseslturl = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
      }
    },
    async OnSCResourceSuccess (res, file, fileList) {
      if (res.res.status === 200) {
        this.sc_slt_url = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
      }
    },
    randomString (num) {
      let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
      let res = ''
      for (let i = 0; i < num; i++) {
        var id = Math.ceil(Math.random() * 35)
        res += chars[id]
      }
      return res
    },
    /**
     * 创建oss客户端对象
     * @returns {*}
     */
    createOssClient () {
      return new Promise((resolve, reject) => {
        let client = new OSS({
          region: 'oss-cn-beijing',
          accessKeyId: global_.ACCESSKEYID,
          accessKeySecret: global_.ACCESSKEYSECRET,
          bucket: global_.BUCTKE
        })
        resolve(client)
      })
    },
    /**
     * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
     * @author   yangxiaoshuo
     * @param    {object}   option [上传选项]
     * @return   {null}   [没有返回]
     */
    async fnUploadRequest (option) {
      var that = this
      let file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        let date = Utils.dateFormat(new Date(), 'yyyyMMdd') // 当前时间
        console.log(date)
        let dateTime = Utils.dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.randomString(4)//  4位随机字符串
        let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        console.log(dateTime)
        console.log(randomStr)
        console.log(extensionName)
        let fileName = global_.CoursePath + file.name // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.createOssClient().then(client => {
          // 异步上传,返回数据
          resolve({
            fileName: file.name,
            fileUrl: fileName
          })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file, {
            progress: function (p) {
              let e = {}
              e.percent = Math.floor(p * 100)
              // console.log('Progress: ' + p)
              option.onProgress(e)
              that.uppercent = e.percent
              console.log(e.percent)
            }
          }).then((val) => {
            if (val.res.statusCode === 200) {
              option.onSuccess(val)
              return val
            } else {
              option.onError('上传失败')
            }
          }, err => {
            option.onError('上传失败')
            reject(err)
          })
        }).catch(errinfo => {
        })
      })
    },
    /**
     * @description [fnUploadSuccess 文件上传成功的函数]
     * @author   shanshuizinong
     * @return   {null}  [没有返回]
     */
    async fnUploadSuccess (res, file, fileList) {
      console.log(res)
      if (res.res.status === 200) {
        var uppath = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
        console.log(uppath)
        console.log(this.upfiletype)
        if (this.upfiletype === 'image') {
          this.pagecontext = this.pagecontext + '<p><img src="' + uppath + '"></p>'
        } else {
          this.pagecontext = this.pagecontext + '<video class="videoinfo" id="videoinfo" src="' + uppath + '" controls="controls" loop="loop"> </video>'
        }
        console.log(this.pagecontext)
      }
      // TODO
    },
    query_cur_course: function () {
      var qstr = 'cusid =' + that.khid
      if (that.course_name !== null && that.course_name !== '') {
        qstr = qstr + " and ctitle like '%" + that.course_name + "%' "
      }
      if (that.course_type !== null && that.course_type !== '' && that.course_type !== 1) {
        qstr = qstr + ' and find_in_set(' + that.course_type + ', owntypes)'
      }
      if (that.sxjtype === '1') {
        qstr = qstr + ' and state = ' + that.sxjtype
      } else if (that.sxjtype === '2') {
        qstr = qstr + ' and state != 1 or state is null '
      }
      that.$options.methods.query_course(qstr)
    },
    query_cur_course_sxj: function () {
      var qstr = 'cusid =' + that.khid
      if (that.course_name !== null && that.course_name !== '') {
        qstr = qstr + " and ctitle like '%" + that.course_name + "%' "
      }
      if (that.course_type !== null && that.course_type !== '' && that.course_type !== 195) {
        qstr = qstr + ' and find_in_set(' + that.course_type + ', owntypes)'
      }
      if (that.sxjtype === '1') {
        qstr = qstr + ' and state = ' + that.sxjtype
      } else if (that.sxjtype === '2') {
        qstr = qstr + ' and state != 1 or state is null '
      }
      console.log(qstr)
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/qci',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: ' order by addtime desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取产品数据')
            localStorage.setItem('courseinfo', res.data.data)
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_course_sxj = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      that.$options.methods.query_course(qstr)
    },
    edit_course_sxj: function (index, data) {
      this.cur_course_data = data[index]
      console.log(this.cur_course_data)
      var tsinfo = ''
      var zstate = 0
      if (this.cur_course_data.state.Int64 === 1) {
        tsinfo = '您确定要下架该课程吗？'
        zstate = 2
      } else {
        tsinfo = '您确定要上架该课程吗？'
        zstate = 1
      }
      this.$confirm(tsinfo, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        var adata = {
          id: {Int64: parseInt(this.cur_course_data.id.Int64), Valid: true},
          state: {Int64: parseInt(zstate), Valid: true},
          cusid: parseInt(this.khid)
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/course/aaucs',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              var qstr
              if (that.sxjtype === '1') {
                qstr = 'cusid=' + that.khid + ' and state=' + that.sxjtype
              } else {
                qstr = 'cusid=' + that.khid + ' and state!=1 or state is null'
              }
              that.$options.methods.query_course(qstr)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/course/CourseMana.vue